export default __webpack_public_path__ + "static/thumbnail-c691384375845061260ce6051b6e9c01.jpg";